// Vérifiez si l'utilisateur a les autorisations nécessaires
export const hasRequiredPermissions = (requiredPermissions: string[], userPermissions: string []): boolean => {
  return requiredPermissions && userPermissions ? requiredPermissions.every((r: string) => userPermissions.includes(r)) : false
}
// Vérifiez si l'utilisateur a les autorisations nécessaires
export const hasRequiredRoles = (requiredRoles: string[], userRoles: string []): boolean => {
  return requiredRoles && userRoles ? requiredRoles.every((r: string) => userRoles.includes(r)) : false
}